module.exports = __webpack_public_path__ + "static/media/copydan_logo.54fd0d1f.svg";